import React from "react";
import { Dialog, DialogTitle, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";
import ColourConstants from "helpers/colourConstants";

const ADD = DeleteDialogStyle();
const PREVIEW_LIMIT = 5;

const useStyles = makeStyles()(() => ({
	list: {
		margin: "12px 0 0",
		paddingLeft: 18,
		fontFamily: "Roboto Condensed",
	},
	more: { color: ColourConstants.commonText, fontStyle: "italic" },
}));

const BulkDeleteTasksDialog = ({
	open,
	tasks,
	taskCaption,
	taskCaptionPlural,
	isDeleting,
	onClose,
	onConfirm,
}) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const count = tasks.length;
	const noun = count === 1 ? taskCaption : taskCaptionPlural;

	return (
		<Dialog
			open={open}
			onClose={isDeleting ? undefined : onClose}
			aria-labelledby="bulk-delete-title"
			aria-describedby="bulk-delete-description"
		>
			{isDeleting ? <LinearProgress /> : null}

			<ADD.ActionContainer>
				<DialogTitle id="bulk-delete-title">
					<ADD.HeaderText>
						{t("title.deleteCountEntity", { count, entity: noun })}
					</ADD.HeaderText>
				</DialogTitle>
				<ADD.ButtonContainer>
					<ADD.CancelButton
						onClick={onClose}
						disabled={isDeleting}
						variant="contained"
						sx={{
							"&.MuiButton-root:hover": {
								backgroundColor: ColourConstants.deleteDialogHover,
								color: "#ffffff",
							},
						}}
					>
						{t("action.cancel")}
					</ADD.CancelButton>
					<ADD.DeleteButton
						onClick={onConfirm}
						disabled={isDeleting}
						variant="contained"
						sx={{
							"&.MuiButton-root:hover": {
								backgroundColor: ColourConstants.deleteDialogHover,
								color: "#ffffff",
							},
						}}
					>
						{t("action.delete")}
					</ADD.DeleteButton>
				</ADD.ButtonContainer>
			</ADD.ActionContainer>

			<ADD.DialogContent>
				<ADD.InputContainer id="bulk-delete-description">
					{t("message.deleteCountEntityConfirm", { count, entity: noun })}
					<ul className={classes.list}>
						{tasks.slice(0, PREVIEW_LIMIT).map((task) => (
							<li key={task.id}>
								{task.taskGroupID} {task.name}
							</li>
						))}
						{count > PREVIEW_LIMIT && (
							<li className={classes.more}>
								{t("message.andCountMore", { count: count - PREVIEW_LIMIT })}
							</li>
						)}
					</ul>
				</ADD.InputContainer>
			</ADD.DialogContent>
		</Dialog>
	);
};

export default BulkDeleteTasksDialog;
